import CustomDataArea from './CustomDataArea';

const NoonCustomData = ({ customData }) => {
  return <CustomDataArea customData={customData} />;
};

export default NoonCustomData;
